import script from "./AbsenceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceDialog.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceDialog.vue?vue&type=style&index=0&id=567b829e&lang=scss"
import "./AbsenceDialog.vue?vue&type=style&index=1&id=567b829e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567b829e"]])

export default __exports__